var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettingsAdjust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "settings-adjust_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.992a1 1 0 011-1h4v2H3a1 1 0 01-1-1zm1 9a1 1 0 100 2h12v-2H3zm14 0v2h4a1 1 0 100-2h-4zm-8-10v2h12a1 1 0 100-2H9z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.992a3 3 0 11-6 0 3 3 0 016 0zm-2 0a1 1 0 11-2 0 1 1 0 012 0zm10 10a3 3 0 11-6 0 3 3 0 016 0zm-2 0a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMiA3Ljk5MmExIDEgMCAwMTEtMWg0djJIM2ExIDEgMCAwMS0xLTF6bTEgOWExIDEgMCAxMDAgMmgxMnYtMkgzem0xNCAwdjJoNGExIDEgMCAxMDAtMmgtNHptLTgtMTB2MmgxMmExIDEgMCAxMDAtMkg5eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSA3Ljk5MmEzIDMgMCAxMS02IDAgMyAzIDAgMDE2IDB6bS0yIDBhMSAxIDAgMTEtMiAwIDEgMSAwIDAxMiAwem0xMCAxMGEzIDMgMCAxMS02IDAgMyAzIDAgMDE2IDB6bS0yIDBhMSAxIDAgMTEtMiAwIDEgMSAwIDAxMiAweiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { SvgSettingsAdjust as ReactComponent };